export default __webpack_public_path__ + "static/media/webchatImg.a3d986a2.png";